import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { getAtletaPorNumero } from "./utils";
import { useLocation } from "react-router-dom";

const Athletes = ({
  tiimeSacador,
  setTiimeSacador, // <- Agora controlamos via prop ou estado pai
  idPartida,
  onChangeHome,
  onChangeVisitor,
  funcaoAtleta,
  lastScout,
  numScout,
  numSet,
  onChangeSacador,
  homeLeft,
  onChangeTeams,
  teams,
  teamNames,
  ultimoSet,
  setters,
}) => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");
  const [homeInputs, setHomeInputs] = useState([]);
  const [visitorInputs, setVisitorInputs] = useState([]);
  const [old, setOld] = useState(0);
  const [novo, setNovo] = useState(0);
  const [isHome, setIsHome] = useState("");
  const [clickOrigin, setClickOrigin] = useState("");
  const [editing, setEditing] = useState({
    team: null,
    idx: null,
    field: null,
  });
  const [editValues, setEditValues] = useState({ name: "", funcao: "" });

  const levantadoresRef = useRef([]);
  const esquerda = homeLeft;

  // Estados para edição dos reservas
  const [editingReserve, setEditingReserve] = useState({
    team: null,
    idx: null,
    field: null,
  });
  const [editReserveValues, setEditReserveValues] = useState({
    name: "",
    funcao: "",
    number: "",
  });

  const [setterInputs, setSetterInputs] = useState([
    setters?.[0] || 1,
    setters?.[1] || 1,
  ]);

  useEffect(() => {
    if (lastScout && lastScout.Rotation) {
      setHomeInputs(lastScout.Rotation.home || []);
      setVisitorInputs(lastScout.Rotation.away || []);
      levantadoresRef.current = [...lastScout.setters];
    }
    setSetterInputs([setters?.[0] || 1, setters?.[1] || 1]);
  }, [lastScout, homeLeft, setters]);

  const rotate = (team, direction = "normal") => {
    const inputs = team === "home" ? [...homeInputs] : [...visitorInputs];
    if (inputs.length < 6) return;

    let newInputs = [...inputs];
    const fixed = inputs[6];

    if (direction === "normal") {
      newInputs = [
        inputs[1],
        inputs[2],
        inputs[3],
        inputs[4],
        inputs[5],
        inputs[0],
        fixed,
      ];
    } else {
      newInputs = [
        inputs[5],
        inputs[0],
        inputs[1],
        inputs[2],
        inputs[3],
        inputs[4],
        fixed,
      ];
    }

    let home = homeInputs;
    let away = visitorInputs;

    if (team === "home") {
      if (direction === "normal") {
        levantadoresRef.current[0] =
          levantadoresRef.current[0] === 1 ? 6 : levantadoresRef.current[0] - 1;
      } else {
        levantadoresRef.current[0] =
          levantadoresRef.current[0] === 6 ? 1 : levantadoresRef.current[0] + 1;
      }
      setHomeInputs(newInputs);
      home = newInputs;
      onChangeHome(newInputs);
      setIsHome(true);
    } else {
      if (direction === "normal") {
        levantadoresRef.current[1] =
          levantadoresRef.current[1] === 1 ? 6 : levantadoresRef.current[1] - 1;
      } else {
        levantadoresRef.current[1] =
          levantadoresRef.current[1] === 6 ? 1 : levantadoresRef.current[1] + 1;
      }
      setVisitorInputs(newInputs);
      away = newInputs;
      onChangeVisitor(newInputs);
      setIsHome(false);
    }

    setClickOrigin(team);
  };

  const updateInput = (team, index, newValue) => {
    setIsHome(team === "home");
    const inputs = team === "home" ? [...homeInputs] : [...visitorInputs];
    const oldValue = inputs[index];
    setOld(oldValue);
    setNovo(newValue);

    inputs[index] = parseInt(newValue, 10);

    if (team === "home") {
      setHomeInputs(inputs);
      onChangeHome(inputs);
    } else {
      setVisitorInputs(inputs);
      onChangeVisitor(inputs);
    }
  };

  const handleSave = async (
    isRotation = false,
    origin = null,
    home = null,
    away = null
  ) => {
    const donoAcao = isHome ? "*" : "a";

    if (!isRotation && numScout - 1 !== 0 && !origin) {
      const codigo = donoAcao + "c" + old + ":" + novo;
      const novaSubstituicao = {
        "*": homeInputs,
        a: visitorInputs,
        sett: lastScout.setters,
        score: lastScout.score,
        setNum: lastScout.setNum,
        // serv: lastScout.serving,
        serv: tiimeSacador,
      };
      try {
        const response = await fetchBlocks(codigo, novaSubstituicao, idPartida);
        const teams = {
          home: response.data["*"],
          away: response.data["a"],
        };

        onChangeTeams(teams);
      } catch (error) {
        console.error(`Erro no bloco de substituicao`, error);
      }
    } else {
      setClickOrigin("");
      try {
        const novosCampos = {
          homeInputs: home ?? homeInputs,
          visitorInputs: away ?? visitorInputs,
          serving: tiimeSacador,
          alterar: numScout - 1,
          setNum: numSet,
          setters: levantadoresRef.current,
          left: homeLeft,
        };
        const response = await axios.put(
          `${
            import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
          }/matches/atletas/${idPartida}`,
          novosCampos
        );
        const resposta = response.data[0];
      } catch (error) {
        console.error("Erro ao salvar alterações:", error);
        alert("Erro ao salvar alterações.");
      }
    }
    window.location.reload();
  };

  const fetchBlocks = async (cod, newScout, idPartida) => {
    const { "*": home, a: away, sett, score, setNum, serv } = newScout;
    const reduzInicial = cod.charAt(0).toLowerCase() + cod.slice(1);
    // Limpa o localStorage para garantir que só a última ação fique registrada
    localStorage.removeItem("lastBlocosIds");

    try {
      const response = await axios.post(
        `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/matches/scout`,
        {
          partida: idPartida,
          home,
          away,
          serv,
          sett,
          score,
          cod: reduzInicial,
          num: setNum,
        }
      );
      const resp = response?.data;
      if (resp && resp._id) {
        // Atualiza o array no localStorage
        const ids = JSON.parse(localStorage.getItem("lastBlocosIds") || "[]");
        ids.push(resp._id);
        localStorage.setItem("lastBlocosIds", JSON.stringify(ids));
      }

      return response || null;
    } catch (error) {
      console.error("Erro ao buscar dados do bloco:", error);
      throw error;
    }
  };

  const startEdit = (team, idx, field, atleta) => {
    setEditing({ team, idx, field });
    setEditValues({
      name: atleta?.name || "",
      funcao: atleta?.funcao || "",
    });
  };

  const cancelEdit = () => {
    setEditing({ team: null, idx: null, field: null });
  };

  const saveEdit = async () => {
    const { team, idx, field } = editing;
    const number = team === "home" ? homeInputs[idx] : visitorInputs[idx];
    const payload = {
      [team]: [
        {
          number: Number(number),
          name: editValues.name,
          function: editValues.funcao,
        },
      ],
    };
    try {
      await axios.put(
        `${
          import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
        }/games/players/${idPartida}`,
        payload
      );
      setEditing({ team: null, idx: null, field: null });
      if (onChangeTeams) {
        onChangeTeams();
      }
    } catch (error) {
      alert("Erro ao salvar atleta");
    }
  };

  const startEditReserve = (team, idx, field, atleta) => {
    setEditingReserve({ team, idx, field });
    setEditReserveValues({
      name: atleta?.name || "",
      funcao: atleta?.function || "",
      number: atleta?.number || "",
    });
  };

  const cancelEditReserve = () => {
    setEditingReserve({ team: null, idx: null, field: null });
  };

  const saveEditReserve = async () => {
    const { team, idx, field } = editingReserve;
    const athlete =
      team === "home"
        ? teams?.home?.filter((ath) => !homeInputs.includes(ath.number))[idx]
        : teams?.away?.filter((ath) => !visitorInputs.includes(ath.number))[
            idx
          ];
    if (!athlete) return;

    // Se estiver editando o número, precisamos do número antigo para identificar o atleta
    const oldNumber = athlete.number;
    const newNumber = editReserveValues.number;

    const payload = {
      [team]: [
        {
          number: newNumber,
          name: editReserveValues.name,
          function: editReserveValues.funcao,
        },
      ],
    };

    try {
      await axios.put(
        `${
          import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
        }/games/players/${idPartida}`,
        payload
      );
      setEditingReserve({ team: null, idx: null, field: null });
      if (onChangeTeams) {
        onChangeTeams();
      }
    } catch (error) {
      alert("Erro ao salvar atleta");
    }
  };

  const deleteReserveAthlete = async (team, idx) => {
    const athlete =
      team === "home"
        ? teams?.home?.filter((ath) => !homeInputs.includes(ath.number))[idx]
        : teams?.away?.filter((ath) => !visitorInputs.includes(ath.number))[
            idx
          ];

    if (!athlete) return;

    const confirmMessage = `Tem certeza que deseja remover o atleta ${
      athlete.name || athlete.number
    } do banco de reservas?`;

    if (!window.confirm(confirmMessage)) {
      return;
    }

    try {
      // Usa a nova rota específica para remover o jogador
      await axios.delete(
        `${
          import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
        }/games/players/${idPartida}`,
        {
          data: {
            team: team,
            playerNumber: athlete.number,
          },
        }
      );
      // Recarrega a página para atualizar a interface
      if (onChangeTeams) {
        onChangeTeams();
      }
    } catch (error) {
      console.error("Erro ao remover atleta:", error);
      alert("Erro ao remover atleta");
    }
  };

  // Handler para atualizar setters no backend
  const handleSetterChange = (idx, value) => {
    const newSetters = [...setterInputs];
    newSetters[idx] = Number(value);
    setSetterInputs(newSetters);
  };

  const handleSetterKeyDown = async (e) => {
    if (e.key === "Enter") {
      try {
        // Atualiza apenas os setters do último scout usando a nova rota específica
        await axios.put(
          `${
            import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
          }/games/setters/${idPartida}`,
          {
            setters: setterInputs,
          }
        );

        // Atualize times ou chame callback para atualizar Scout.jsx
        if (onChangeTeams) onChangeTeams();
      } catch (error) {
        console.error("Erro ao atualizar setters:", error);
        alert("Erro ao atualizar setters");
      }
    }
  };

  if (!lastScout || !lastScout.Rotation) {
    return <div>Carregando dados da rotação...</div>;
  }

  const totalRows = Math.max(homeInputs.length, visitorInputs.length);
  const rowLabels = [1, 2, 3, 4, 5, 6, "LB"];

  const ActionButtons = ({ position }) => (
    <div className="flex flex-col items-center space-y-2">
      <button
        type="button"
        tabIndex={0}
        onClick={() => rotate(position, "normal")}
        className="text-gray-400 hover:text-gray-600"
      >
        <svg
          className="w-4 h-4"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
          pointerEvents="none"
        >
          <path d="M5 15l7-7 7 7" />
        </svg>
      </button>
      <button
        tabIndex={0}
        type="button"
        onClick={() => rotate(position, "inverse")}
        className="text-gray-400 hover:text-gray-600"
      >
        <svg
          className="w-4 h-4"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
          pointerEvents="none"
        >
          <path d="M19 9l-7 7-7-7" />
        </svg>
      </button>
    </div>
  );

  return (
    <div className="flex flex-col items-center w-full">
      {/* Cabeçalho das colunas */}
      <div className="flex flex-row justify-center items-end w-full max-w-2xl mb-1">
        <div className="w-8 mr-2" />
        <div
          className="w-32 text-end text-xs font-semibold cursor-pointer select-none"
          onClick={() => onChangeSacador("*")}
        >
          <span
            className={
              tiimeSacador === "*" ? "text-blue-600 font-bold" : "text-gray-700"
            }
          >
            {teamNames?.home?.name}
          </span>
        </div>
        <div className="w-16 text-center text-[10px] font-regular text-gray-400 select-none">
          Posição
        </div>
        <div
          className="w-32 text-start text-xs font-semibold cursor-pointer select-none"
          onClick={() => onChangeSacador("a")}
        >
          <span
            className={
              tiimeSacador === "a" ? "text-red-600 font-bold" : "text-gray-700"
            }
          >
            {teamNames?.away?.name}
          </span>
        </div>
        <div className="w-8 ml-2" />
      </div>
      {/* Linhas de dados */}
      <div className="flex flex-row justify-center items-start w-full max-w-2xl">
        {/* Botões de rotação Home */}
        <div className="flex flex-col items-center justify-center w-8 mr-2">
          {/* {numScout === 1 && <ActionButtons position="home" />} */}
          {isAdminRoute && <ActionButtons position="home" />}
        </div>
        {/* Colunas de dados empilhadas por linha */}
        <div className="flex flex-col w-full">
          {rowLabels.map((label, idx) => {
            const atletaHome = getAtletaPorNumero(homeInputs[idx], teams?.home);
            const atletaVisitor = getAtletaPorNumero(
              visitorInputs[idx],
              teams?.away
            );

            return (
              <div
                key={idx}
                className="flex flex-row items-center justify-center min-h-[32px]"
              >
                {/* Nome Local */}
                <div className="text-end w-full rounded-s-full  border-r-0 mr-[-10px] border-blue-500 border p-1 pr-4 text-xs text-gray-500 truncate flex items-center justify-end">
                  {/* Função Home */}
                  {isAdminRoute &&
                  editing.team === "home" &&
                  editing.idx === idx &&
                  editing.field === "funcao" ? (
                    <input
                      type="text"
                      value={editValues.funcao}
                      autoFocus
                      onChange={(e) =>
                        setEditValues((ev) => ({
                          ...ev,
                          funcao: e.target.value,
                        }))
                      }
                      onBlur={cancelEdit}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") saveEdit();
                      }}
                      className="w-10 ml-1 border border-blue-400 rounded text-center"
                    />
                  ) : (
                    <span
                      className="text-red-400 cursor-pointer hover:underline relative group text-right"
                      onClick={
                        isAdminRoute
                          ? () => startEdit("home", idx, "funcao", atletaHome)
                          : undefined
                      }
                      title={isAdminRoute ? "Editar função" : undefined}
                    >
                      {atletaHome?.funcao || (
                        <svg
                          className="inline w-3 h-3 text-gray-300 group-hover:text-gray-500"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          viewBox="0 0 24 24"
                        >
                          <path d="M12 20h9" />
                          <path d="M16.5 3.5a2.121 2.121 0 1 1 3 3L7 19.5 3 21l1.5-4L16.5 3.5z" />
                        </svg>
                      )}
                    </span>
                  )}
                  {/* Nome Home */}
                  {isAdminRoute &&
                  editing.team === "home" &&
                  editing.idx === idx &&
                  editing.field === "name" ? (
                    <input
                      type="text"
                      value={editValues.name}
                      autoFocus
                      onChange={(e) =>
                        setEditValues((ev) => ({ ...ev, name: e.target.value }))
                      }
                      onBlur={cancelEdit}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") saveEdit();
                      }}
                      className="w-16 border border-blue-400 rounded"
                    />
                  ) : (
                    <span
                      onClick={
                        isAdminRoute
                          ? () => startEdit("home", idx, "name", atletaHome)
                          : undefined
                      }
                      className="cursor-pointer relative group text-right ml-1"
                      title={isAdminRoute ? "Editar nome" : undefined}
                    >
                      {atletaHome?.name || (
                        <svg
                          className="inline w-3 h-3 text-gray-300 group-hover:text-gray-500"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          viewBox="0 0 24 24"
                        >
                          <path d="M12 20h9" />
                          <path d="M16.5 3.5a2.121 2.121 0 1 1 3 3L7 19.5 3 21l1.5-4L16.5 3.5z" />
                        </svg>
                      )}
                    </span>
                  )}
                </div>
                {/* Input Local (número) */}
                <input
                  type="number"
                  value={homeInputs[idx] || ""}
                  onChange={(e) => updateInput("home", idx, e.target.value)}
                  placeholder={`Jogador ${idx + 1}`}
                  className={
                    idx === 6
                      ? "w-12 text-center text-grey-400 bg-white border-2 border-blue-600 rounded-full h-7 mx-1"
                      : "w-12 text-center text-white bg-blue-600 rounded-full  h-7 mx-1"
                  }
                />
                {/* Número central */}
                <div className="w-10 text-center text-gray-400 font-thin text-sm">
                  {label}
                </div>
                {/* Input Visitante */}
                <input
                  type="number"
                  value={visitorInputs[idx] || ""}
                  onChange={(e) => updateInput("visitor", idx, e.target.value)}
                  placeholder={`Jogador ${idx + 1}`}
                  className={
                    idx === 6
                      ? "w-12 text-center text-grey-400 bg-white border-2 border-red-600 rounded-full h-7 mx-1"
                      : "w-12 text-center text-white bg-red-600 rounded-full h-7 mx-1"
                  }
                />
                {/* Nome Visitante */}
                <div className="w-full text-left pl-4 border border-l-0 border-red-500 p-1 rounded-e-full ml-[-10px] text-xs text-gray-500 truncate flex items-center">
                  {isAdminRoute &&
                  editing.team === "away" &&
                  editing.idx === idx &&
                  editing.field === "name" ? (
                    <input
                      type="text"
                      value={editValues.name}
                      autoFocus
                      onChange={(e) =>
                        setEditValues((ev) => ({ ...ev, name: e.target.value }))
                      }
                      onBlur={cancelEdit}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") saveEdit();
                      }}
                      className="w-16 mr-1 border border-blue-400 rounded"
                    />
                  ) : (
                    <span
                      onClick={
                        isAdminRoute
                          ? () => startEdit("away", idx, "name", atletaVisitor)
                          : undefined
                      }
                      className="cursor-pointer relative group"
                      title={isAdminRoute ? "Editar nome" : undefined}
                    >
                      {atletaVisitor?.name || (
                        <svg
                          className="inline w-3 h-3 text-gray-300 group-hover:text-gray-500"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          viewBox="0 0 24 24"
                        >
                          <path d="M12 20h9" />
                          <path d="M16.5 3.5a2.121 2.121 0 1 1 3 3L7 19.5 3 21l1.5-4L16.5 3.5z" />
                        </svg>
                      )}
                    </span>
                  )}
                  {isAdminRoute &&
                  editing.team === "away" &&
                  editing.idx === idx &&
                  editing.field === "funcao" ? (
                    <input
                      type="text"
                      value={editValues.funcao}
                      autoFocus
                      onChange={(e) =>
                        setEditValues((ev) => ({
                          ...ev,
                          funcao: e.target.value,
                        }))
                      }
                      onBlur={cancelEdit}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") saveEdit();
                      }}
                      className="w-10 ml-1 border border-blue-400 rounded text-center"
                    />
                  ) : (
                    <span
                      className="text-red-400 ml-1 cursor-pointer hover:underline relative group"
                      onClick={
                        isAdminRoute
                          ? () =>
                              startEdit("away", idx, "funcao", atletaVisitor)
                          : undefined
                      }
                      title={isAdminRoute ? "Editar função" : undefined}
                    >
                      {atletaVisitor?.funcao || (
                        <svg
                          className="inline w-3 h-3 text-gray-300 group-hover:text-gray-500"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          viewBox="0 0 24 24"
                        >
                          <path d="M12 20h9" />
                          <path d="M16.5 3.5a2.121 2.121 0 1 1 3 3L7 19.5 3 21l1.5-4L16.5 3.5z" />
                        </svg>
                      )}
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
        {/* Botões de rotação Visitor */}
        <div className="flex flex-col items-center justify-center w-8 ml-2">
          {/* {numScout === 1 && <ActionButtons position="visitor" />} */}
          {isAdminRoute && <ActionButtons position="visitor" />}
        </div>
      </div>

      {/* Exibe o botão Gravar apenas se numSet === ultimoSet */}
      <div className="text-center p-4">
        <button
          className={`w-24 rounded py-1 ${
            isAdminRoute && parseInt(numSet) === parseInt(ultimoSet)
              ? "bg-gray-300 hover:bg-gray-400"
              : "bg-gray-200 text-gray-400 cursor-not-allowed"
          }`}
          onClick={() => handleSave()}
          disabled={!(isAdminRoute && parseInt(numSet) === parseInt(ultimoSet))}
        >
          Gravar
        </button>
      </div>
      {/* Campos para editar setters */}

      {/* {numScout === 1 && isAdminRoute && ( */}
      {isAdminRoute && parseInt(numSet) === parseInt(ultimoSet) && (
        <div>
          <span className="text-gray-400">
            Posição inicial dos levantadores
          </span>
          <div className="flex flex-row gap-4 items-center justify-center mb-2">
            <div>
              <input
                type="number"
                value={setterInputs[0]}
                min={1}
                max={6}
                className="w-12 border border-gray-300 rounded text-center"
                onChange={(e) => handleSetterChange(0, e.target.value)}
                onKeyDown={handleSetterKeyDown}
              />
            </div>
            <div>
              <input
                type="number"
                value={setterInputs[1]}
                min={1}
                max={6}
                className="w-12 border border-gray-300 rounded text-center"
                onChange={(e) => handleSetterChange(1, e.target.value)}
                onKeyDown={handleSetterKeyDown}
              />
            </div>
          </div>
        </div>
      )}
      <span className="text-center text-gray-400 text-md mt-4">Reservas</span>
      {/* Listagem dos atletas dos times */}
      <div className="flex flex-row w-full max-w-2xl mt-4">
        {/* Coluna Home */}
        <div className="flex-1 flex flex-col items-end pr-2">
          {teams?.home
            ?.filter((ath) => !homeInputs.includes(ath.number))
            .map((ath, idx) => {
              const isSelected = homeInputs.includes(ath.number);
              return (
                <div
                  key={ath.number || idx}
                  className={`w-full flex flex-row justify-end items-center gap-2 ${
                    isSelected ? "text-blue-600 bg-white font-bold" : ""
                  }`}
                >
                  {/* Função editável */}
                  {isAdminRoute &&
                  editingReserve.team === "home" &&
                  editingReserve.idx === idx &&
                  editingReserve.field === "funcao" ? (
                    <input
                      type="text"
                      value={editReserveValues.funcao}
                      autoFocus
                      onChange={(e) =>
                        setEditReserveValues((ev) => ({
                          ...ev,
                          funcao: e.target.value,
                        }))
                      }
                      onBlur={cancelEditReserve}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") saveEditReserve();
                      }}
                      className="w-10 border border-blue-400 rounded text-center"
                    />
                  ) : (
                    <span
                      className="text-xs text-red-600 cursor-pointer "
                      onClick={
                        isAdminRoute
                          ? () => startEditReserve("home", idx, "funcao", ath)
                          : undefined
                      }
                      title={isAdminRoute ? "Editar função" : undefined}
                    >
                      {ath.function || (
                        <svg
                          className="inline w-3 h-3 text-gray-300"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          viewBox="0 0 24 24"
                        >
                          <path d="M12 20h9" />
                          <path d="M16.5 3.5a2.121 2.121 0 1 1 3 3L7 19.5 3 21l1.5-4L16.5 3.5z" />
                        </svg>
                      )}
                    </span>
                  )}
                  {/* Nome editável */}
                  {isAdminRoute &&
                  editingReserve.team === "home" &&
                  editingReserve.idx === idx &&
                  editingReserve.field === "name" ? (
                    <input
                      type="text"
                      value={editReserveValues.name}
                      autoFocus
                      onChange={(e) =>
                        setEditReserveValues((ev) => ({
                          ...ev,
                          name: e.target.value,
                        }))
                      }
                      onBlur={cancelEditReserve}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") saveEditReserve();
                      }}
                      className="w-16 border border-blue-400 rounded"
                    />
                  ) : (
                    <span
                      className="text-xs cursor-pointer "
                      onClick={
                        isAdminRoute
                          ? () => startEditReserve("home", idx, "name", ath)
                          : undefined
                      }
                      title={isAdminRoute ? "Editar nome" : undefined}
                    >
                      {ath.name || (
                        <svg
                          className="inline w-3 h-3 text-gray-300"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          viewBox="0 0 24 24"
                        >
                          <path d="M12 20h9" />
                          <path d="M16.5 3.5a2.121 2.121 0 1 1 3 3L7 19.5 3 21l1.5-4L16.5 3.5z" />
                        </svg>
                      )}
                    </span>
                  )}
                  {/* Número editável */}
                  {isAdminRoute &&
                  editingReserve.team === "home" &&
                  editingReserve.idx === idx &&
                  editingReserve.field === "number" ? (
                    <input
                      type="number"
                      value={editReserveValues.number}
                      autoFocus
                      onChange={(e) =>
                        setEditReserveValues((ev) => ({
                          ...ev,
                          number: e.target.value,
                        }))
                      }
                      onBlur={cancelEditReserve}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") saveEditReserve();
                      }}
                      className="w-12 border border-blue-400 rounded text-center"
                    />
                  ) : (
                    <span
                      className="text-xs cursor-pointer hover:bg-gray-100 px-1 rounded"
                      onClick={
                        isAdminRoute
                          ? () => startEditReserve("home", idx, "number", ath)
                          : undefined
                      }
                      title={isAdminRoute ? "Editar número" : undefined}
                    >
                      {ath.number}
                    </span>
                  )}
                  {/* Ícone de exclusão */}
                  {isAdminRoute && (
                    <button
                      onClick={() => deleteReserveAthlete("home", idx)}
                      className="ml-1 text-red-400 hover:text-red-600 transition-colors"
                      title="Remover atleta"
                    >
                      <svg
                        className="w-3 h-3"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        viewBox="0 0 24 24"
                      >
                        <path d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                    </button>
                  )}
                </div>
              );
            })}
        </div>
        {/* Espaço central */}
        <div className="w-20" />
        {/* Coluna Away */}
        <div className="flex-1 flex flex-col items-start pl-2">
          {teams?.away
            ?.filter((ath) => !visitorInputs.includes(ath.number))
            .map((ath, idx) => {
              const isSelected = visitorInputs.includes(ath.number);
              return (
                <div
                  key={ath.number || idx}
                  className={`w-full flex flex-row justify-start items-center gap-2 ${
                    isSelected ? "text-red-600 font-bold" : ""
                  }`}
                >
                  {/* Ícone de exclusão */}
                  {isAdminRoute && (
                    <button
                      onClick={() => deleteReserveAthlete("away", idx)}
                      className="mr-1 text-red-400 hover:text-red-600 transition-colors"
                      title="Remover atleta"
                    >
                      <svg
                        className="w-3 h-3"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        viewBox="0 0 24 24"
                      >
                        <path d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                    </button>
                  )}
                  {/* Número editável */}
                  {isAdminRoute &&
                  editingReserve.team === "away" &&
                  editingReserve.idx === idx &&
                  editingReserve.field === "number" ? (
                    <input
                      type="number"
                      value={editReserveValues.number}
                      autoFocus
                      onChange={(e) =>
                        setEditReserveValues((ev) => ({
                          ...ev,
                          number: e.target.value,
                        }))
                      }
                      onBlur={cancelEditReserve}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") saveEditReserve();
                      }}
                      className="w-12 border border-blue-400 rounded text-center"
                    />
                  ) : (
                    <span
                      className="text-xs cursor-pointer hover:bg-gray-100 px-1 rounded"
                      onClick={
                        isAdminRoute
                          ? () => startEditReserve("away", idx, "number", ath)
                          : undefined
                      }
                      title={isAdminRoute ? "Editar número" : undefined}
                    >
                      {ath.number}
                    </span>
                  )}
                  {/* Nome editável */}
                  {isAdminRoute &&
                  editingReserve.team === "away" &&
                  editingReserve.idx === idx &&
                  editingReserve.field === "name" ? (
                    <input
                      type="text"
                      value={editReserveValues.name}
                      autoFocus
                      onChange={(e) =>
                        setEditReserveValues((ev) => ({
                          ...ev,
                          name: e.target.value,
                        }))
                      }
                      onBlur={cancelEditReserve}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") saveEditReserve();
                      }}
                      className="w-16 border border-blue-400 rounded"
                    />
                  ) : (
                    <span
                      className="text-xs cursor-pointer "
                      onClick={
                        isAdminRoute
                          ? () => startEditReserve("away", idx, "name", ath)
                          : undefined
                      }
                      title={isAdminRoute ? "Editar nome" : undefined}
                    >
                      {ath.name || (
                        <svg
                          className="inline w-3 h-3 text-gray-300"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          viewBox="0 0 24 24"
                        >
                          <path d="M12 20h9" />
                          <path d="M16.5 3.5a2.121 2.121 0 1 1 3 3L7 19.5 3 21l1.5-4L16.5 3.5z" />
                        </svg>
                      )}
                    </span>
                  )}
                  {/* Função editável */}
                  {isAdminRoute &&
                  editingReserve.team === "away" &&
                  editingReserve.idx === idx &&
                  editingReserve.field === "funcao" ? (
                    <input
                      type="text"
                      value={editReserveValues.funcao}
                      autoFocus
                      onChange={(e) =>
                        setEditReserveValues((ev) => ({
                          ...ev,
                          funcao: e.target.value,
                        }))
                      }
                      onBlur={cancelEditReserve}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") saveEditReserve();
                      }}
                      className="w-10 border border-blue-400 rounded text-center"
                    />
                  ) : (
                    <span
                      className="text-xs text-red-600 cursor-pointer "
                      onClick={
                        isAdminRoute
                          ? () => startEditReserve("away", idx, "funcao", ath)
                          : undefined
                      }
                      title={isAdminRoute ? "Editar função" : undefined}
                    >
                      {ath.function || (
                        <svg
                          className="inline w-3 h-3 text-gray-300"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          viewBox="0 0 24 24"
                        >
                          <path d="M12 20h9" />
                          <path d="M16.5 3.5a2.121 2.121 0 1 1 3 3L7 19.5 3 21l1.5-4L16.5 3.5z" />
                        </svg>
                      )}
                    </span>
                  )}
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default Athletes;
